import { render, staticRenderFns } from "./CfgSlider.vue?vue&type=template&id=6b80621e&scoped=true"
import script from "./CfgSlider.vue?vue&type=script&lang=ts"
export * from "./CfgSlider.vue?vue&type=script&lang=ts"
import style0 from "./CfgSlider.vue?vue&type=style&index=0&id=6b80621e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80621e",
  null
  
)

export default component.exports